import {renderElement} from "../utils/common";

const getToastTemplate = (text: string) => `<div class="alerts__item">
  <button class="alerts__close" type="button" aria-label="Закрыть уведомление"></button>
  <p class="alerts__text">${text}</p>
</div>`;

const getToastWrapper = () => `<div class="alerts"></div>`;

class Toast {
  private parent: HTMLElement = this.renderParent();

  renderToast(text: string) {
    const newToast: HTMLElement = (renderElement(this.parent, getToastTemplate(text)) as HTMLElement);

    this.addCloseEvent(newToast);
    this.addCloseTimer(newToast);
  }

  private renderParent(): HTMLElement {
    return (document.querySelector(`.alerts`) as HTMLElement) || renderElement(document.body, getToastWrapper());
  }

  private hideToast(element: HTMLElement) {
    element.classList.add(`alerts__item--hide`);

    setTimeout(() => {
      element.remove();
    }, 650);
  }

  private addCloseTimer(toast: HTMLElement) {
    setTimeout(() => {
      this.hideToast(toast);
    }, 4000);
  }

  private addCloseEvent(toast: HTMLElement) {
    toast.querySelector(`.alerts__close`)!
      .addEventListener(`click`, () => {
        this.hideToast(toast);
      });
  }
}

const toast = new Toast();

const showToast = (text: string) => {
  toast.renderToast(text);
};

export {showToast};
